module.exports = __webpack_public_path__ + "img/title_short_bg02.57f5357d.png";